// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';

// Components
import { selectDataUser } from 'connect/selectors';

import { FunnelProvider } from '../../../../funnel/storage/Storage';
import { PartnerMatchProvider } from '../../../../partner/storage/Storage';
import CheckoutModalStepHandler from '../CheckoutModalStepHandler/CheckoutModalStepHandler';

// Other

// Component
const CheckoutModal = ({ history, location, match }) => {
  const user = useSelector(selectDataUser);
  const isPartner = !!_.get(user, 'partner');

  const stepHandler = (
    <CheckoutModalStepHandler
      history={history}
      location={location}
      routeMatch={match}
      isPartner={isPartner}
    />
  );

  return isPartner
    ?     <PartnerMatchProvider>{stepHandler}</PartnerMatchProvider>
    :     <FunnelProvider>{stepHandler}</FunnelProvider>
  ;
};

CheckoutModal.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default CheckoutModal;
